import React from 'react';
import '../styles/export-branding.css';

const ExportHeader: React.FC = ({ ...props }: { className?: string, [key: string]: any }) => {
  return (
    <header {...props}>
      <div className="header-bar"></div>
      <div className="text-center text-sm text-muted-foreground py-2">
        Essential Eight Assessment for {sessionStorage.getItem('e8-lead-company') || 'Unknown Company'} requested by {sessionStorage.getItem('e8-lead-email') || 'Unknown User'}
      </div>
    </header>
  );
};

export default ExportHeader;
